<script lang="ts" setup>
import { useBuilderStore } from '@/store/builder'
import { Settings01Icon } from '@gohighlevel/ghl-icons/24/outline'
import { computed } from 'vue'
import { UITooltip } from '@gohighlevel/ghl-ui'
import { usePropertiesDrawer } from '@/composable/usePropertiesDrawer'
import { ELEMENTS_LOOKUP } from '@gohighlevel/ghl-proposals-common'

const props = defineProps({
  sectionType: {
    type: String,
    required: true,
  },
  activeSection: {
    type: String,
    default: null,
  },
})

const store = useBuilderStore()
const { setOpen } = usePropertiesDrawer()

const isHeaderSection = computed(() => props.sectionType === 'headers')
const isFooterSection = computed(() => props.sectionType === 'footers')

const isSectionActive = computed(() => {
  // Use the store's activation state to ensure consistency with the highlight
  // This ensures the overlay and highlight appear/disappear together
  if (isHeaderSection.value) {
    return store.isHeaderSectionActive
  } else {
    return store.isFooterSectionActive
  }
})

function openSettings() {
  if (isHeaderSection.value) {
    store.updateHeaderSelected(true)
  } else {
    store.updateFooterSelected(true)
  }

  const section = store.pages[0]?.component?.options?.[props.sectionType]
  if (section) {
    section.type = ELEMENTS_LOOKUP.PAGE_SECTION
    store.updateActiveElement(section)
  }
  setOpen()
}
</script>

<template>
  <div
    v-if="store.isDocumentEditable && isSectionActive"
    class="actions flex z-20 overlay-actions animate-slideUp"
    :class="{
      'absolute bottom-[-34px] left-[45%]': isHeaderSection,
      'absolute top-[100%] left-[45%] mt-1': isFooterSection,
    }"
  >
    <div
      class="flex items-center bg-gray-charcoal border border-gray-700 shadow-float p-[4px] rounded-sm"
    >
      <span class="text-white text-xs mr-2 select-none">
        {{
          isHeaderSection
            ? $t('common.header').toUpperCase()
            : $t('common.footer').toUpperCase()
        }}
      </span>
      <UITooltip>
        <template #trigger>
          <div
            class="hover:bg-gray-600 w-full cursor-pointer flex"
            @click="openSettings"
          >
            <Settings01Icon class="text-white p-1 text-sm h-4 w-4" />
          </div>
        </template>
        {{ $t('common.settings') }}
      </UITooltip>
    </div>
  </div>
</template>

<style scoped>
.overlay-actions {
  transition: all 0.2s ease-in-out;
}
</style>
